module.exports = __webpack_public_path__ + "static/media/puertovallarta.edfa09a0.jpg";